<template>
  <svg :viewBox="sprites[name].viewBox">
    <use :xlink:href="'#'+sprites[name].id" />
  </svg>
</template>

<script>

  import * as sprites from "../../sprites/*.svg"

  export default {
    name: 'sprite',
    props: {
      name: { type: String, required: true }
    },
    data () {
      return {
        sprites
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import "~globals";

</style>



// WEBPACK FOOTER //
// src/components/_global/sprite.vue